import { PayloadAction } from '@reduxjs/toolkit';

export const getPayload = <TPayload>(action: PayloadAction<TPayload>): TPayload => action.payload;
